import $ from 'jquery';

import { logAmplitudeClickEvent, NavigationPosition } from 'chairisher/util/analytics';
import { isMaxMediumDesktop } from 'chairisher/util/mediaquery';

/**
 * Track a click event on the product nav horizontal
 *
 * @param {Event} e The event fired
 */
export function trackProductNavigationHorizontalLinkClick(e) {
    const $link = $(e.currentTarget);
    const ctaName = `/${$link.text().trim()}`;

    logAmplitudeClickEvent(ctaName, NavigationPosition.PRODUCT_NAV_HORIZONTAL, $link.attr('href'));
}

/**
 * Track a click event on the product nav
 *
 * @param {Event} e The event fired
 */
export function trackProductNavigationLinkClick(e) {
    const $link = $(e.currentTarget);

    const linkText = $link.text().trim();
    let parentText = null;
    let ctaName = null;

    if ($link.hasClass('js-initiator')) {
        if (isMaxMediumDesktop() || $link.attr('href') === '#') {
            return; // don't track an event when expanding mobile navigation or if href is '#'
        }

        ctaName = linkText;
    } else {
        parentText = $link.closest('.js-product-nav-item').children('.js-initiator').text().trim();
        ctaName = `${parentText}/${linkText}`;
    }

    logAmplitudeClickEvent(ctaName, NavigationPosition.PRODUCT_NAV, $link.attr('href'));
}

/**
 * Track a click event on the cart icon
 *
 * @param {Event} e The event fired
 */
export function trackHeaderCartIconClick(e) {
    const $link = $(e.currentTarget);
    logAmplitudeClickEvent('View Cart', NavigationPosition.HEADER_CART_ICON, $link.attr('href'));
}

/**
 * Track a click event on the discover designers cta on the cross site nav
 *
 * @param {Event} e The event fired
 */
export function trackDiscoverNavLinkClick(e) {
    const $link = $(e.currentTarget);
    logAmplitudeClickEvent($link.text().trim(), NavigationPosition.DESIGNER_DIRECTORY_CTA, $link.attr('href'));
}

/**
 * Track a click event on the favorites drop down menu items
 *
 * @param {Event} e The event fired
 */
export function trackFavoritesMenuItem(e) {
    const $link = $(e.currentTarget);
    logAmplitudeClickEvent(
        $link.find('.favorites-nav-link-titles').text(),
        NavigationPosition.FAVORITES_DROP_DOWN_MENU,
        $link.attr('href'),
    );
}

/**
 * Tracks a click event for the Message of the Day (MOTD) banner
 *
 * @param {Event} e The event fired
 */
export function trackMotdLinkClick(e) {
    const $link = $(e.currentTarget);
    logAmplitudeClickEvent($link.text().trim(), NavigationPosition.MOTD, $link.attr('href'));
}
